// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__K9vKO","selected":"Chip_selected__1JwZu"};